import { fetchJson } from '@api/ApiHelper';
import { Locale } from '@components/common/language_menu/languagesMap';

/**
 * Note that unlike other create endpoints, this endpoint
 * does not return the values that were created
 * This is because POST /api/v4/custom_field_keys/:key/custom_field_values
 * supports accepting multiple assets and it is not feasible to
 * return the created custom field values in the response
 */
export const createCustomFieldValues = (
  values: { value: string; assetKey: string }[],
  customFieldKeyId: string,
  ugtLocale?: Locale | ''
): Promise<{}> => {
  const url = `/api/v4/custom_field_keys/${customFieldKeyId}/custom_field_values`;
  const formattedValuesWithAssets = values.map(({ value, assetKey }) => ({
    attributes: {
      value
    },
    relationships: {
      asset: {
        data: {
          type: "assets",
          id: assetKey
        }
      }
    }
  }));
  return fetchJson({
    url,
    method: 'POST',
    body: {
      ugt_locale: ugtLocale || undefined,
      data: formattedValuesWithAssets
    }
  });
};
